import { setMeta } from '@/helpers/metaHelpers.js'

export default {
  watch: {
    $page(page) {
      setMeta(page.seo)
    },
  },
  mounted() {
    if (this.$page) setMeta(this.$page.seo)
  },
}
